@import (reference) '../../../styles/variables.less';
@import (reference) '../../../styles/input.less';
@import (reference) '../../../styles/functions.less';

:host {
  display: block;
  font: @lt-font-primary;

  .input-container {
    .input();
    .input-size-medium();
    .input-standard-text();

    padding-left: 8px;
    padding-right: 8px;
    position: relative;
    will-change: auto;

    ::slotted(ltc-icon[slot="leftIcon"]) {
      .font-size-em(24);

      transition: all 150ms;
    }

    ::slotted(ltc-icon[slot="rightIcon"]) {
      .font-size-em(24);

      position: absolute;
      right: 8px;
      top: 10px;
    }

    .input-label {
      position: absolute;
      transform: translate(4px);
      transition: transform 150ms;
      will-change: auto;

      .font-size-em(16);

      &.left-icon-shift {
        transform: translate(20px);
      }
    }

    &.ltc-input-labelled {
      &:focus-within,
      &.ltc-input-filled {
        padding-bottom: 0;
        padding-left: 8px;
        will-change: auto;

        ::slotted(ltc-icon[slot="leftIcon"]) {
          .font-size-em(20);

          transition: all 150ms;
        }

        .input-label {
          .font-size-em(12);

          transform: translate(0, -20px);
          transition: transform 150ms;
        }
      }
    }
  }
}
